// extracted by mini-css-extract-plugin
export default {"detail":"index_detail__wadaD"};